import type { LoadstoneConfig } from './loadstone-types'

export const thinkingLoadstoneConfig = {
  rows: 5,
  columns: 5,
  animation: 'pulse',
  duration: 900,
  stagger: 90,
  gap: 3,
  radius: 3,
  ledMode: false,
  cells: [
    [0, 2, 2],
    [1, 1, 1],
    [1, 2, 2],
    [1, 3, 3],
    [2, 0, 0],
    [2, 1, 1],
    [2, 3, 3],
    [2, 4, 4],
    [3, 1, 1],
    [3, 2, 2],
    [3, 3, 3],
    [4, 2, 2],
  ].map(([row, column, order]) => ({
    row,
    column,
    order,
    lightColor: '#3A57C8',
    darkColor: '#3A57C8',
    opacity: 0.18,
    scale: 0.45,
  })),
} satisfies LoadstoneConfig

const contextBusyProps = {
  lightColor: '#0079ff',
  darkColor: '#0079ff',
  opacity: 0.15,
  scale: 1,
}

export const contextBusyConfig: LoadstoneConfig = {
  rows: 6,
  columns: 6,
  animation: 'glow',
  duration: 1200,
  stagger: 220,
  gap: 0,
  radius: 0,
  ledMode: false,
  cells: [
    { row: 0, column: 2, order: 0, ...contextBusyProps },
    { row: 0, column: 3, order: 1, ...contextBusyProps },
    { row: 1, column: 1, order: 9, ...contextBusyProps },
    { row: 1, column: 2, order: 8, ...contextBusyProps },
    { row: 1, column: 3, order: 7, ...contextBusyProps },
    { row: 1, column: 4, order: 2, ...contextBusyProps },
    { row: 2, column: 0, order: 20, ...contextBusyProps },
    { row: 2, column: 1, order: 10, ...contextBusyProps },
    { row: 2, column: 2, order: 11, ...contextBusyProps },
    { row: 2, column: 3, order: 12, ...contextBusyProps },
    { row: 2, column: 4, order: 6, ...contextBusyProps },
    { row: 2, column: 5, order: 3, ...contextBusyProps },
    { row: 3, column: 0, order: 19, ...contextBusyProps },
    { row: 3, column: 1, order: 21, ...contextBusyProps },
    { row: 3, column: 2, order: 23, ...contextBusyProps },
    { row: 3, column: 3, order: 13, ...contextBusyProps },
    { row: 3, column: 4, order: 5, ...contextBusyProps },
    { row: 3, column: 5, order: 4, ...contextBusyProps },
    { row: 4, column: 1, order: 18, ...contextBusyProps },
    { row: 4, column: 2, order: 22, ...contextBusyProps },
    { row: 4, column: 3, order: 15, ...contextBusyProps },
    { row: 4, column: 4, order: 14, ...contextBusyProps },
    { row: 5, column: 2, order: 17, ...contextBusyProps },
    { row: 5, column: 3, order: 16, ...contextBusyProps },
  ],
}

const contextReadyEdge = { lightColor: '#2eea89', darkColor: '#5cffde', opacity: 0.8, scale: 1 }
const contextReadyBody = { lightColor: '#1fc16e', darkColor: '#1fbf9f', opacity: 0.8, scale: 1 }
const contextReadyShade = { lightColor: '#1d9f56', darkColor: '#0e7762', opacity: 0.8, scale: 1 }

export const contextReadyConfig: LoadstoneConfig = {
  rows: 6,
  columns: 6,
  animation: 'glow',
  duration: 1800,
  stagger: 220,
  gap: 0,
  radius: 0,
  ledMode: false,
  cells: [
    { row: 0, column: 2, order: 0, ...contextReadyEdge },
    { row: 0, column: 3, order: 0, ...contextReadyEdge },
    { row: 1, column: 1, order: 1, ...contextReadyBody },
    { row: 1, column: 2, order: 1, ...contextReadyBody },
    { row: 1, column: 3, order: 1, ...contextReadyBody },
    { row: 1, column: 4, order: 0, ...contextReadyEdge },
    { row: 2, column: 0, order: 2, ...contextReadyBody },
    { row: 2, column: 1, order: 2, ...contextReadyBody },
    { row: 2, column: 2, order: 2, ...contextReadyBody },
    { row: 2, column: 3, order: 2, ...contextReadyBody },
    { row: 2, column: 4, order: 1, ...contextReadyBody },
    { row: 2, column: 5, order: 0, ...contextReadyEdge },
    { row: 3, column: 0, order: 3, ...contextReadyShade },
    { row: 3, column: 1, order: 3, ...contextReadyBody },
    { row: 3, column: 2, order: 3, ...contextReadyBody },
    { row: 3, column: 3, order: 3, ...contextReadyBody },
    { row: 3, column: 4, order: 2, ...contextReadyBody },
    { row: 3, column: 5, order: 1, ...contextReadyBody, darkColor: '#5cffde' },
    { row: 4, column: 1, order: 4, ...contextReadyShade },
    { row: 4, column: 2, order: 4, ...contextReadyBody },
    { row: 4, column: 3, order: 4, ...contextReadyBody },
    { row: 4, column: 4, order: 3, ...contextReadyBody },
    { row: 5, column: 2, order: 5, ...contextReadyShade },
    { row: 5, column: 3, order: 4, ...contextReadyShade },
  ],
}
